import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { TasksCheckedPayload } from './interfaces/tasks-checked-payload.interface';
import { isNonNullObject } from 'utilities';

export const TasksCheckedMessage: MessageHandler<TasksCheckedPayload> = {
  send(payload: TasksCheckedPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.TasksChecked, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is TasksCheckedPayload {
    if (!isNonNullObject(payload)) return false;
    const p = payload as Record<string, unknown>;
    return (
      typeof p['team'] === 'string' &&
      p['team'].length > 0 &&
      typeof p['project'] === 'string' &&
      p['project'].length > 0 &&
      Array.isArray(p['tasks']) &&
      (p['tasks'] as unknown[]).every(t => typeof t === 'string')
    );
  },
};
